module.exports = __webpack_public_path__ + "img/population.c8c0d019.webp";